/**
 * P2A — one read-only location catalogue for the current Tome I workspace
 * and the future Editorial product → space → category picker.
 *
 * Labels/order come from the EXISTING ProductWorkspace, without changing its
 * visual design. IDs are explicit and stable: a title edit must not silently
 * redirect an existing publication.
 *
 * This catalogue does NOT publish, change access, connect Reader or write DB.
 * "Превращения" currently has no authored subcategory list in ProductWorkspace;
 * intentionally keep it empty instead of inventing publishable destinations.
 */
export const ALMOND_PRODUCT_ID = "78917116-d963-45dd-946c-7797db939790";

export const ALMOND_PUBLICATION_SPACES = [
  {
    key: "almond", number: "01", title: "Исследуем миндаль",
    subtitle: "История, происхождение, свойства и формы ингредиента.",
    categories: [
      { id: "history-tradition", title: "История и традиция" },
      { id: "origin-botany", title: "Происхождение и ботаника" },
      { id: "types-forms", title: "Виды и формы миндаля" },
      { id: "raw-roasted", title: "Сырой и обжаренный миндаль" },
      { id: "flour", title: "Миндальная мука" },
      { id: "paste", title: "Миндальная паста" },
      { id: "praline", title: "Пралине" },
      { id: "marzipan", title: "Марципан" },
      { id: "almond-cream-frangipane", title: "Миндальный крем и франжипан" },
      { id: "taste-aroma-texture", title: "Вкус, аромат и текстура" },
      { id: "selection-storage", title: "Выбор и хранение" },
      { id: "roasting", title: "Обжарка и усиление вкуса" },
      { id: "substitutions-limits", title: "Замены и ограничения" },
    ],
  },
  {
    key: "recipes", number: "02", title: "Библиотека рецептур",
    subtitle: "Проверенные компоненты, технологии и профессиональные связи.",
    categories: [
      { id: "biscuits-baked-bases", title: "Бисквиты и выпеченные основы" },
      { id: "shortcrust-tart-bases", title: "Песочное тесто и тартовые основы" },
      { id: "almond-cream-frangipane", title: "Миндальный крем и франжипан" },
      { id: "creams", title: "Кремы" },
      { id: "cremeux", title: "Кремю" },
      { id: "ganaches", title: "Ганаши и ganache montée" },
      { id: "mousses", title: "Муссы" },
      { id: "confit-compote", title: "Конфи и компоте" },
      { id: "caramels", title: "Карамели" },
      { id: "praline", title: "Пралине" },
      { id: "crunchy-layers", title: "Хрустящие прослойки" },
      { id: "soaking", title: "Пропитки" },
      { id: "glazes-coatings", title: "Глазури и покрытия" },
    ],
  },
  {
    key: "collection", number: "03", title: "Авторская коллекция",
    subtitle: "Торты, тарты, тарталетки, шу и премиальное печенье.",
    categories: [
      { id: "cakes", title: "Авторские торты", count: 12 },
      { id: "tarts", title: "Сезонные тарты", count: 6 },
      { id: "tartlets", title: "Премиальные тарталетки", count: 6 },
      { id: "choux", title: "Авторские шу", count: 3 },
      { id: "cookies", title: "Премиальное печенье", count: null },
    ],
  },
  {
    key: "transformations", number: "04", title: "Превращения",
    subtitle: "Как одна база превращается в десятки новых решений.",
    categories: [],
  },
];

export const ALMOND_RECIPE_CATEGORIES =
  ALMOND_PUBLICATION_SPACES.find((s) => s.key === "recipes").categories.map((c) => c.title);
export const ALMOND_RESEARCH_CATEGORIES =
  ALMOND_PUBLICATION_SPACES.find((s) => s.key === "almond").categories.map((c) => c.title);
export const ALMOND_COLLECTION_CATEGORIES =
  ALMOND_PUBLICATION_SPACES.find((s) => s.key === "collection").categories.map((c) => ({
    key: c.id, title: c.title, count: c.count,
  }));

/**
 * Resolve known canonical destination by ID, never by its mutable display name.
 * Returns null rather than inventing a target for unknown or placeholder groups.
 */
export function getAlmondPublicationLocation(spaceKey, categoryId) {
  const space = ALMOND_PUBLICATION_SPACES.find((s) => s.key === spaceKey);
  const category = space?.categories.find((c) => c.id === categoryId);
  if (!space || !category) return null;
  return {
    productId: ALMOND_PRODUCT_ID,
    spaceId: space.key,
    spaceTitle: space.title,
    categoryId: category.id,
    categoryTitle: category.title,
  };
}
